import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLoader } from '../../../helpers/useLoader';
import { IUserService } from '../../user/user.service';
import { ListViewMode } from '../../user/user.store';
import { useAttachmentsService } from '../attachments.service';
import { AttachmentsListControls } from '../components/AttachmentsListControls';

export const AttachmentsListControlsContainer = observer((): ReactElement => {
  const attachmentsService = useAttachmentsService();
  const userService = useInjection(IUserService.$);

  const { withLoaderAsync } = useLoader();
  const { workspaceId, attachmentId } = useParams<{ workspaceId: string; attachmentId: string }>();

  useEffect(() => {
    attachmentsService.store.selectedAttachments = { isAllSelected: false, ids: [] };
  }, []);

  const handleOrderByChange = async (orderBy: string): Promise<void> => {
    const paging = attachmentsService.store.getPaging(workspaceId, attachmentId);
    paging.orderBy = orderBy;
    attachmentsService.store.updatePaging(paging);
    await doSort();
  };

  const handleOrderDirectionChange = async (orderType: string): Promise<void> => {
    const paging = attachmentsService.store.getPaging(workspaceId, attachmentId);
    paging.orderType = orderType;
    attachmentsService.store.updatePaging(paging);
    await doSort();
  };

  const handleViewModeChange = async (mode: ListViewMode): Promise<void> => {
    await userService.setAttachmentsListViewMode(mode);
  };

  const doSort = async (): Promise<void> => {
    await withLoaderAsync(async () => attachmentsService.getAttachmentsAsync(attachmentId));
  };

  const attachmentsStore = attachmentsService.store;
  const paging = attachmentsStore.getPaging(workspaceId, attachmentId);

  return (
    <AttachmentsListControls
      viewMode={userService.data.attachmentsListViewMode}
      orderBy={paging.orderBy || ''}
      orderDirection={paging.orderType || ''}
      onViewModeChange={handleViewModeChange}
      onOrderByChange={handleOrderByChange}
      onOrderDirectionChange={handleOrderDirectionChange}
    />
  );
});
